export default function Announcement() {
  return (
    <div>
      <div className="text-center font-semi-bold text-base p-2">
        Welcome to our shop! Enjoy free shipping on all orders.
      </div>
    </div>
  );
}
